<div class="container-fluid vh-100 bg-light">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <div class="card shadow">
        <div class="card-body p-5">
          <!-- Title -->
          <div class="text-center mb-4">
            <h2 class="fs-3">Jelszó visszaállítása</h2>
          </div>

          <!-- Form Section -->
          <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
            <!-- New Password -->
            <div class="mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Új jelszó</mat-label>
                <input
                  matInput
                  [type]="hideNewPassword() ? 'password' : 'text'"
                  formControlName="newPassword"
                  autocomplete="new-password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hideNewPassword.set(!hideNewPassword())"
                  [attr.aria-label]="'Jelszó ' + (hideNewPassword() ? 'megjelenítés' : 'elrejtés')"
                  [attr.aria-pressed]="!hideNewPassword()"
                >
                  <mat-icon>{{ hideNewPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Password Requirements -->
            <div class="mb-4">
              <div class="password-requirements">
                <div class="requirement" [class.valid]="passwordRequirements().minLength">
                  <mat-icon class="requirement-icon">{{
                    passwordRequirements().minLength ? 'check' : 'close'
                  }}</mat-icon>
                  <span class="requirement-text">Legalább 8 karakter hosszúság kötelező!</span>
                </div>
                <div class="requirement" [class.valid]="passwordRequirements().hasUpperCase">
                  <mat-icon class="requirement-icon">{{
                    passwordRequirements().hasUpperCase ? 'check' : 'close'
                  }}</mat-icon>
                  <span class="requirement-text">Legalább 1 nagybetű használata kötelező!</span>
                </div>
                <div class="requirement" [class.valid]="passwordRequirements().hasLowerCase">
                  <mat-icon class="requirement-icon">{{
                    passwordRequirements().hasLowerCase ? 'check' : 'close'
                  }}</mat-icon>
                  <span class="requirement-text">Legalább 1 kisbetű használata kötelező!</span>
                </div>
                <div class="requirement" [class.valid]="passwordRequirements().hasNumber">
                  <mat-icon class="requirement-icon">{{
                    passwordRequirements().hasNumber ? 'check' : 'close'
                  }}</mat-icon>
                  <span class="requirement-text">Legalább 1 szám használata kötelező!</span>
                </div>
                <div class="requirement" [class.valid]="passwordRequirements().hasSpecialChar">
                  <mat-icon class="requirement-icon">{{
                    passwordRequirements().hasSpecialChar ? 'check' : 'close'
                  }}</mat-icon>
                  <span class="requirement-text"
                    >Legalább 1 speciális karakter használata kötelező!</span
                  >
                </div>
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Új jelszó megerősítése</mat-label>
                <input
                  matInput
                  [type]="hideConfirmPassword() ? 'password' : 'text'"
                  formControlName="confirmPassword"
                  autocomplete="new-password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hideConfirmPassword.set(!hideConfirmPassword())"
                  [attr.aria-label]="
                    'Jelszó ' + (hideConfirmPassword() ? 'megjelenítés' : 'elrejtés')
                  "
                  [attr.aria-pressed]="!hideConfirmPassword()"
                >
                  <mat-icon>{{ hideConfirmPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Password Match Validation -->
            @if (passwordForm.get('confirmPassword')?.value) {
            <div class="mb-3">
              <div
                class="password-match"
                [class.valid]="passwordsMatch()"
                [class.invalid]="!passwordsMatch()"
              >
                <mat-icon class="match-icon">{{ passwordsMatch() ? 'check' : 'close' }}</mat-icon>
                <span class="match-text">{{
                  passwordsMatch() ? 'Jelszavak megegyeznek' : 'Jelszavak nem egyeznek'
                }}</span>
              </div>
            </div>
            }

            <!-- Submit Button -->
            <div class="d-grid">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="!passwordForm.valid || isLoading()"
              >
                {{ isLoading() ? 'Mentés...' : 'Jelszó módosítása' }}
              </button>
            </div>

            <!-- Back to Login -->
            <div class="text-center mt-3">
              <a routerLink="/" class="text-decoration-none">Vissza a bejelentkezéshez</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
